export default "__VITE_ASSET__BQ5xCW$5__"